export enum MemberOrganizationEnum {
  ACTOR = "Actor",
  OBSERVER = "Observer",
  LEAD_ACTOR = "Lead-Actor",
  SUPER_ACTOR = "Super-Actor",
  GROUPS = "Groups",
}
